import { Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Testimony from "./Pages/Testimony";
import Photos from "./Pages/Photos";
import Services from "./Pages/Services";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppChat from "./components/WhatsApp";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
   useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true,     // whether animation happens only once
      easing: "ease-out", // easing style
    });
  }, []);

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/testimony" element={<Testimony />} />
        <Route path="/photos" element={<Photos />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <WhatsAppChat />
      <Footer />
    </>
  );
}
